import { tableCellClasses } from '@mui/material/TableCell';
import { colors } from 'Constants/Colors';

const tableContainerStyle = {
  background: 'white',
  width: '93%',
  margin: 'auto',
  borderBottom: 'none',
  alignItems: 'flex-end',
};

const tableStyle = {
  minWidth: 650,
  borderCollapse: 'separate',
  borderSpacing: '0px 5px',
  background: `${colors.BLUE_GRAY} !important`,
  height: '20vh',
  overflow: 'auto',
  [`& .${tableCellClasses.root}`]: {
    borderBottom: 'none',
  },
};

const tableHead = {
  background: colors.BLUE_GRAY,
};

const tableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  background: colors.WHITE,
  alignItems: 'center',
};
const subtableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  [`& .${tableCellClasses.root}`]: {
    marginTop: 0,
  },
  background: colors.WHITE,
};

const tableCellStyle = {
  fontWeight: 'bold',
};
export default {
  tableContainerStyle,
  tableStyle,
  tableHead,
  tableRowStyle,
  tableCellStyle,
  subtableRowStyle,
};
